import { render, staticRenderFns } from "./bread-crumbs.vue?vue&type=template&id=511fb79c&scoped=true"
import script from "./bread-crumbs.vue?vue&type=script&lang=ts"
export * from "./bread-crumbs.vue?vue&type=script&lang=ts"
import style0 from "./bread-crumbs.vue?vue&type=style&index=0&id=511fb79c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511fb79c",
  null
  
)

export default component.exports